var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-period basic-block"},[_c('h1',[_vm._v("開催期間")]),_vm._v(" "),_c('p',{staticClass:"period",domProps:{"innerHTML":_vm._s(_vm.period)}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30087536","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/lp/campaign/LineCampaign202110/blocks/BlockPeriod.vue
// module id = null
// module chunks = 